import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export interface FilingType {
  id: string;
  displayName: string;
}

export interface GetFilingTypesResponse {
  filingTypes: FilingType[];
  count: number;
}

export function useGetFilingTypes(token?: string) {
  const url = 'content/filings';

  const {
    data,
    error,
    mutate,
  }: {
    data?: GetFilingTypesResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
